import Vue from 'vue';
import eventBus from '../common/js/event-bus/event-bus';
import { mediaQueries } from '../common/js/media-query/media-query';
import HeaderComponent from '../frame-vue/header/header.vue';
import FooterComponent from '../frame-vue/footer/footer.vue';
import i18n from '../common/js/lang/lang';
import store from '../common/js/store/store';
import currencyFilter from '../common/js/currency-filter/currency-filter';
import VueModal from '@ui-common/vue-modal';
import PortalVue from 'portal-vue';
import VueScrollTo from 'vue-scrollto';
import VueCookies from 'vue-cookies';
import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
	// debug: true
	loadScript: false
});
Vue.use(VueCookies);
Vue.filter('currency', currencyFilter);
Vue.use(VueModal);
Vue.use(PortalVue);
Vue.use(VueScrollTo);

export default {
	store,
	data: {
		ariaHide: false,
		modalVisible: null,
		allowAnchor: true
	},
	i18n,
	components: {
		HeaderComponent,
		FooterComponent
	},
	mediaQueries,
	methods: {
		waitForFonts() {
			if (location.hash) {
				let wait = setInterval(() => {
					if (document.documentElement.classList.contains('wf-active')) {
						var elId = location.hash.replace('#', '');
						var scrollToEl = document.getElementById(elId) || document.querySelector(`a[name="${elId}]"`);
						if (scrollToEl) {
							scrollToEl.scrollIntoView(true);
						}
						clearInterval(wait);
					}
				}, 500);
				setTimeout(() => {
					clearInterval(wait);
				}, 5000);
			}
		}
	},
	mounted: function() {
		this.$nextTick(() => {
			this.allowAnchor && this.waitForFonts();
		});
		eventBus.$on('toggleAriaHidden', hide => {
			this.ariaHide = hide;
		});
		eventBus.$on('sidenav-toggle', isOpen => {
			const root = document.documentElement;
			const openSidenavClass = 'sidebar-is-open';
			if (isOpen) {
				root.classList.add(openSidenavClass);
			} else {
				root.classList.remove(openSidenavClass);
			}
		});
	}
};
